import { useQuery } from '@tanstack/react-query';

import { getPersonalExpense } from '../personalExpenses';
import { getProjectExpense } from '../projectExpenses';
import { ExpenseFormType } from '@/pages/register/expenses/types';

export const EXPENSE_ATTACHMENTS_KEY = 'ExpenseAttachments';

export const useGetExpenseAttachments = (
  expenseType: ExpenseFormType,
  expenseId: number | null,
) => {
  const { data, ...restProps } = useQuery({
    queryKey: [EXPENSE_ATTACHMENTS_KEY, expenseId, expenseType],
    queryFn: () =>
      expenseType === 'personal'
        ? getPersonalExpense(expenseId!)
        : getProjectExpense(expenseId!),
    enabled: !!expenseId,
    refetchIntervalInBackground: true,
    staleTime: 15 * 60 * 1000, // 15 minutes
    refetchInterval: 14 * 60 * 1000, // 14 minutes
  });

  return { data: data?.fileUrls, ...restProps };
};
